module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_7_m.7ccdaad95d93b726a9f53a16a20f99aa.png";